<template>
  <!-- Add Diagnosis -->
  <div
    ref="diagnosisCardElement"
    class="card claim-collection-add-card"
    :class="{ 'teal lighten-5': !error, 'red lighten-5': error }"
    v-if="diagnosisCard"
  >
    <div class="card-content">
      <div class="row">
        <form class="col s12" @submit.prevent="handleDiagnosis">
          <div class="row">
            <div class="col s12">
              <span class="card-title">{{
                resetDiagnosis ? "Edit Diagnosis" : "Add Diagnosis"
              }}</span>
            </div>

            <div class="input-field col s12 claim-diagnosis-field">
              <label for="diagnosis">Diagnosis</label>
              <input
                v-model="diagnosis"
                id="diagnosis"
                type="text"
                placeholder="Enter diagnosis"
                :disabled="isSubmitting"
              />
            </div>

            <p v-if="diagnosisSaveError" class="col s12 red-text" role="alert">{{ diagnosisSaveError }}</p>

            <div class="input-field col s12 claim-entry-actions">
              <a
                class="waves-effect claim-entry-button claim-entry-cancel"
                :class="{ disabled: isSubmitting }"
                :aria-disabled="isSubmitting"
                @click.prevent="!isSubmitting && handleRefresh('diagnosis')"
              >
                <i class="medium material-icons left">clear</i>Cancel
              </a>

               <!-- Breaker -->
              <span class="co1 m7 claim-entry-spacer"></span>

              <button
                  type="button"
                  class="waves-effect claim-entry-button claim-entry-primary"
                  :disabled="!diagnosis?.trim() || isSubmitting"
                  :class="{ 'green': diagnosis, 'disabled': !diagnosis || isSubmitting }"
                  @click.prevent="handleDiagnosis"
              >
                <i class="medium material-icons left">{{
                  isSubmitting ? "hourglass_empty" : resetDiagnosis ? "sync" : confirmMissingDiagnosis ? "check" : "chevron_right"
                }}</i
                >{{ isSubmitting ? "Saving..." : resetDiagnosis ? "Confirm Edit" : confirmMissingDiagnosis ? "Confirm" : "Next" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Add Claims -->
  <div
    ref="claimsCardElement"
    class="card claim-add-card"
    :class="{ 'teal lighten-5': !error, 'red lighten-5': error }"
    v-if="claimsCard"
  >
    <div class="card-content">
      <div class="row">
        <form class="col s12">
          <div class="row">
            <div class="col s12">
              <span class="card-title">Select Item
                <span class="secondary-content tariff-card-actions">
                  <button type="button" class="btn-flat tariff-card-icon-action tariff-preview-top-action"
                    title="View tariff items" @click.prevent="handleTariffPreview" v-if="hasTariffs && !isTariffLoading">
                    <i class="material-icons">visibility</i>
                  </button>
                  <i class="material-icons tariff-mini-spin grey-text" v-if="isTariffLoading">autorenew</i>
                  <button type="button" class="btn-flat tariff-card-icon-action" title="Refresh tariff items"
                    @click.prevent="handleTariffReload" v-else>
                    <i class="material-icons">refresh</i>
                  </button>
                </span>
              </span>
            </div>
            <div class="col s12" v-if="tariffMessage && !isTariffLoading">
              <p class="tariff-card-message">{{ tariffMessage }}</p>
            </div>
            <div class="input-field col s12 m6 claim-item-field">
              <TariffSearch
                inputId="filterClaim"
                :data="filterData"
                :startAgain="resetClaim"
                :startEdit="editClaim"
                :disabled="isTariffLoading || !hasTariffs"
                @selected="handlePick"
                @searching="handleSearch"
                @clear="handleClear"
              />
            </div>
            <div class="input-field col s6 m3 claim-item-field">
              <label for="qty">Quantity</label>
              <input
                v-model="qty"
                @input="handlePricing"
                id="qty"
                type="number"
                placeholder="0"
              />
            </div>
            <div class="input-field col s6 m3 claim-item-field">
              <label for="amt">Amount Charged</label>
              <input v-model="amt" id="amt" type="number" placeholder="0.00" readonly />
            </div>

            <div class="input-field col s12 claim-entry-actions">
              <a
                class="waves-effect claim-entry-button claim-entry-cancel"
                @click.prevent="handleClaimCancel"
              >
                <i class="medium material-icons left">clear</i>Cancel
              </a>

              <a
                  v-if="(type == 'claim') && (editId == null)"
                  class="waves-effect claim-entry-button claim-entry-next"
                  :class="{
                    green: !(selectedItem && qty && amt) && claimsList.length,
                  }"
                  @click="handleNext('review')"
                  ><i class="medium material-icons left">chevron_right</i>Next</a
                >

                <!-- Breaker -->
                <span class="co1 m5 claim-entry-spacer"></span>

              <button
                class="waves-effect claim-entry-button claim-entry-primary"
                :class="{ pulse: addPulse }"
                @click.prevent="handleClaims"
              >
                <i class="medium material-icons left">{{
                  editId ? "sync" : "add"
                }}</i
                >{{ editId ? "Edit Item" : "Add Item" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <div class="tariff-preview-overlay" :data-ui-template="uiTemplate.id" @click.self="handleTariffPreviewClose" @keydown.esc.prevent.stop="handleTariffPreviewClose" v-if="isTariffPreviewOpen">
      <section :id="tariffModalId" class="tariff-preview-modal" role="dialog" aria-modal="true" aria-label="Tariff items">
        <header class="tariff-preview-heading">
          <div><h2>Tariff items</h2><p>Review available items and their rates.</p></div>
          <button type="button" class="tariff-preview-close" aria-label="Close tariff items" @click.prevent="handleTariffPreviewClose"><i class="material-icons" aria-hidden="true">close</i></button>
        </header>
        <div class="tariff-preview-content">
          <div class="tariff-preview-search">
            <label :for="`${tariffModalId}-search`">Search tariff items</label>
            <input ref="tariffPreviewSearchInput" class="browser-default" v-model="tariffPreviewSearch" :id="`${tariffModalId}-search`" type="search" placeholder="Search by item name" autocomplete="off" />
          </div>
          <p class="tariff-preview-count" aria-live="polite">{{ filteredTariffPreview.length }} {{ filteredTariffPreview.length === 1 ? 'item' : 'items' }}</p>
          <ul class="collection tariff-preview-list" v-if="filteredTariffPreview.length">
            <li class="collection-item" v-for="tariff in filteredTariffPreview" :key="`${tariff.item}-${tariff.price}`">
              <span>{{ tariff.item }}</span>
              <b class="secondary-content">&#8358;{{ formatMoney(tariff.price) }}</b>
            </li>
          </ul>
          <p class="grey-text" v-else>No tariff item matches your search.</p>
        </div>
        <div class="tariff-preview-footer">
          <button type="button" class="tariff-preview-done" @click.prevent="handleTariffPreviewClose">Close</button>
        </div>
      </section>
    </div>
  </Teleport>
</template>
  
<script>
import { ref, onMounted, computed, nextTick, watch, watchEffect } from "vue";
import getItems from "@/composables/getItems";
import TariffSearch from "@/components/search/TariffSearch.vue";
import { urlFormat } from "@/composables/tariff/urlFormat";
import { getCache, addCache, removeCache } from "@/composables/cache/cache";
import { capitalizeFirstLetter } from "@/composables/fxLibrary/coreFx.js";
import uiTemplate from "@/ui/active-template";

export default {
  name: "AddClaimComponent",
  emits: ["update", "clear", "item-added", "diagnosis-ready"],
  props: ["turl", "type", "next", "reload", "editDiagnosis", "claimItem", "persistDiagnosis", "cancelDiagnosisToHome", "confirmMissingDiagnosis"],
  components: { TariffSearch },
  setup(props, context) {
    const tariffPreviewSearchInput = ref(null);
    let tariffPreviewOpener = null;
    const responseDefault = ref([]);
    const isSubmitting = ref(false);
    const responseSearch = ref([]);
    const error = ref(false);
    const diagnosisSaveError = ref("");
    const addPulse = ref(false);
    const submitPulse = ref(false);
    const diagnosis = ref(null);
    const diagnosisList = ref([]);
    const diagnosisCard = ref(true);
    const diagnosisCardElement = ref(null);
    const selectedItem = ref(null);
    const selectedPrice = ref(null);
    const resetDiagnosis = ref(false);
    const editClaim = ref(null);
    const editId = ref(null);
    const resetClaim = ref(false);
    const claimsCard = ref(false);
    const claimsCardElement = ref(null);
    const claimsDisplayCard = ref(false);
    const claimsSubmitCard = ref(false);
    const claimsList = ref([]);
    const claim = ref(null);
    const qty = ref(null);
    const amt = ref(null);
    const tariffUrl = ref(null);
    const isTariffLoading = ref(false);
    const tariffError = ref(null);
    const tariffLoaded = ref(false);
    const tariffPreviewSearch = ref("");
    const isTariffPreviewOpen = ref(false);
    const tariffModalId = `claimCollectionTariffPreview-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const hasTariffs = computed(() => responseDefault.value.length > 0);
    const tariffMessage = computed(() => {
      if (tariffError.value) {
        return tariffError.value;
      }
      if (tariffLoaded.value && !hasTariffs.value) {
        return "No tariff item is available for this scheme and provider.";
      }
      return null;
    });
    const filteredTariffPreview = computed(() => {
      const term = tariffPreviewSearch.value?.toLowerCase();
      if (!term) {
        return responseDefault.value;
      }
      return responseDefault.value.filter(x => x.item?.toLowerCase().includes(term));
    });

    const emitDiagnosisReady = async () => {
      await nextTick();

      if (diagnosisCard.value && diagnosisCardElement.value) {
        context.emit("diagnosis-ready", diagnosisCardElement.value);
      }
    };

    // data tariff
    const filterData = computed(() => {
      // start
      let val = {};

      let valPlus;

      if (responseSearch.value) {
        valPlus = responseSearch.value.reduce((newArr, x) => {
          newArr[x.item] = null;
          return newArr;
        }, {});
        val = { ...val, ...valPlus };
      }

      // return final
      return val;
    });

    // search function
    const getTariffFromApi = async (table, force = false) => {
      if (!table) {
        tariffError.value = "Unable to load tariff items for this scheme and provider.";
        tariffLoaded.value = true;
        return;
      }
      tariffUrl.value = table;
      tariffError.value = null;
      // get item from store (cache)
      let cacheTariff = getCache(table);
      // get from api
      if (cacheTariff?.length && !force) {
        responseDefault.value = cacheTariff;
        tariffLoaded.value = true;
      } else {
        isTariffLoading.value = true;
        const { res, err } = await getItems(table);
        if (res.value) {
          // search
          responseDefault.value = res.value.data || [];
          // add cache
          addCache(table, responseDefault.value);
        } else {
          tariffError.value = err.value || "Unable to load tariff items for this scheme and provider.";
        }
        tariffLoaded.value = true;
        isTariffLoading.value = false;
      }
    };

    // updte auth
    onMounted(() => {
      // get props
      if (props.reload) {
        // skip diagnosis
        diagnosis.value = props.reload;
        // call diagnosis handle
        handleDiagnosis();
      }
    });

    // starter (set loading spin)
    onMounted(() => {
      // tariff url
      let url = urlFormat(props.turl);
      // get items from function
      getTariffFromApi(url);
    });

    onMounted(emitDiagnosisReady);

    watch(diagnosisCard, value => {
      if (value) {
        emitDiagnosisReady();
      }
    });

    const handleTariffReload = () => {
      if (!tariffUrl.value) {
        return;
      }
      removeCache(tariffUrl.value);
      getTariffFromApi(tariffUrl.value, true);
    };

    const handleTariffPreview = async () => {
      tariffPreviewOpener = document.activeElement;
      tariffPreviewSearch.value = "";
      isTariffPreviewOpen.value = true;
      await nextTick();
      tariffPreviewSearchInput.value?.focus();
    };

    const handleTariffPreviewClose = () => {
      isTariffPreviewOpen.value = false;
      tariffPreviewOpener?.focus?.();
    };

    const formatMoney = (val) => {
      return Number(val || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // add up
    const totalSent = (claims) => {
      let total = 0;
      claims.forEach((x) => {
        total = Number(total) + Number(x.amt);
      });
      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // refresh field
    const handleRefresh = (type) => {
      if (type === "diagnosis") {
        if (props.cancelDiagnosisToHome) {
          if (isSubmitting.value) {
            return;
          }

          context.emit("clear", {
            id: "restartEncounter",
            value: true,
          });
          return;
        }

        resetDiagnosis.value = false;
        // clear entry
        diagnosis.value = null;
        // clear pulse (if needed)
        addPulse.value = false;
        // clear error (if needed)
        error.value = false;
         // clear resetDiagnosis in parent (if needed)
        context.emit("clear", {
          id: "resetDiagnosis",
          value: false,
        });
      } else if (type === "claim") {
        // clear entry
        claimInputClear();
      }
      // redirect
      if (claimsList.value.length) {
        handleNext("review");
      } else {
        handleNext("claims");
      }
    };

    // null diagnosis crew
    const handleReviewDiagnosis = () => {
      // clear diagnosis
      diagnosisCard.value = true;
      // true claims
      claimsCard.value = false;
      claimsDisplayCard.value = false;
      claimsSubmitCard.value = false;
      // clear everything about diagnosis
      diagnosis.value = diagnosisList.value.join(", ");
      resetDiagnosis.value = true;

      // clear entry (insurance)
      claimInputClear();

      // clear edit (if needed)
      editId.value = null;
      // clear pulse (if needed)
      addPulse.value = false;
      // clear error (if needed)
      error.value = false;
    };

    // delete claim
    const handleDelete = (claim) => {
      // mark status as delete
      claimsList.value = claimsList.value.filter((x) => x.id != claim.id);
      // clear all input
      claimInputClear();
      // check if all has been removed
      if (!claimsList.value.length) {
        handleNext("claims");
      }
    };

    const handleClaimCancel = () => {
      if (!claimsList.value.length && !selectedItem.value && !qty.value && !amt.value) {
        context.emit("clear", {
          id: "restartEncounter",
          value: true,
        });
        return;
      }

      handleRefresh("claim");
    };

    // clear every selected claim without touching diagnosis
    const handleClearClaims = () => {
      claimsList.value = [];
      claimInputClear();
      handleNext("claims");
    };

    // edit claim
    const handleEdit = (claim) => {
      // for child component
      editClaim.value = claim.claim;

      // for main
      editId.value = claim.id;
      selectedItem.value = claim.claim;
      selectedPrice.value = claim.standard;
      qty.value = claim.qty;
      amt.value = claim.amt;

      // clear submit outlook
      handleNext("moreClaims");
    };

    // null diagnosis input field
    const handleClearInput = (field) => {
      if (field === "diagnosis") {
        resetDiagnosis.value = false;
        // clear diagnosis
        diagnosis.value = null;
        // clear pulse (if needed)
        addPulse.value = false;
        // clear error (if needed)
        error.value = false;
      }
    };

    // handle diagnosis
    const handleDiagnosis = async () => {
      if (isSubmitting.value) return;
      if (diagnosis.value?.trim()) {
        diagnosisSaveError.value = "";
        // format for saving
        const { fx } = capitalizeFirstLetter(diagnosis.value.trim());

        if ((resetDiagnosis.value && props.persistDiagnosis) || props.confirmMissingDiagnosis) {
          isSubmitting.value = true;
          try {
            const savedEncounter = await props.persistDiagnosis?.(fx.value);
            if (!String(savedEncounter?.diagnosis || "").trim()) {
              throw new Error("Diagnosis could not be saved. Please try again.");
            }
            fx.value = savedEncounter.diagnosis;
          } catch {
            error.value = true;
            diagnosisSaveError.value = "Diagnosis could not be saved. Please try again.";
            return;
          } finally {
            isSubmitting.value = false;
          }
        }

        // add to or override diagnosis array
        if (resetDiagnosis.value) {
          diagnosisList.value = [];
          diagnosisList.value.push(fx.value);
        } else {
          diagnosisList.value.push(fx.value);
        }

        // null result
        diagnosis.value = null;
        // reset error (if required)
        error.value = false;
        // clear pulse (if required)
        addPulse.value = false;

        // clear entry (insurance)
        claimInputClear();

         // move straight to review (if edit)
         if (resetDiagnosis.value) {
            resetDiagnosis.value = false;
            // emit clear
            context.emit("clear", {
            id: "resetDiagnosis",
            value: false,
          });
          }

          // Auto-Next
          if (claimsList.value.length) {
              handleNext("review");
            } else {
              handleNext("claims");
            }

      } else {
        error.value = true;
      }
    };

    // clear inputs
    const claimInputClear = () => {
      // clear all
      selectedItem.value = null;
      selectedPrice.value = null;
      resetClaim.value = true; // will clear claims input
      qty.value = null;
      amt.value = null;
      responseSearch.value = [];

      // clear edit (if needed)
      editId.value = null;
      // clear editId in parent (if needed)
      context.emit("clear", {
          id: "editId",
          value: null,
      });
      // clear pulse (if needed)
      addPulse.value = false;
      // clear error (if needed)
      error.value = false;
    };

    // load claims
    const handleClaims = () => {
      // start action
      if (selectedItem.value && qty.value && amt.value) {
        // format for saving
        const { fx } = capitalizeFirstLetter(selectedItem.value);

        if (editId.value) {
          // edit
          const index = claimsList.value.findIndex(
            (x) => x.id === editId.value
          );
          if (index !== -1) {
            // found record
            claimsList.value[index] = {
              ...claimsList.value[index],
              claim: fx.value,
              qty: qty.value,
              amt: amt.value,
            };
          }
        } else {
          // add to claims array
          claimsList.value.push({
            id: Date.now(),
            claim: fx.value,
            qty: qty.value,
            amt: amt.value,
            standard: Number(selectedPrice.value).toFixed(2),
          });
        }

        // clear entry
        claimInputClear();

        /*
        Auth parents onlt
        Others will skip this
        */
        if (props.type == "auth") {
          handleNext("review");
        }

        // reset error (if required)
        error.value = false;
        context.emit("item-added");
      } else {
        error.value = true;
      }

      // open display
      if (claimsList.value.length) {
        claimsDisplayCard.value = true;
      }
    };

    // handle next
    const handleNext = async (next) => {
      if (next === "claims") {
        if (!diagnosis.value && diagnosisList.value.length) {
          // clear diagnosis
          diagnosisCard.value = false;
          // true claims
          claimsCard.value = true;
          claimsDisplayCard.value = false;
          claimsSubmitCard.value = false;
          // clear everything about diagnosis
          diagnosis.value = null;

          // reset error (if required)
          error.value = false;
        } else {
          // set error
          error.value = true;
          // set pulse
          if (diagnosis.value) {
            addPulse.value = true;
          }
        }
      } else if (next === "review") {
        if (
          !(selectedItem.value && qty.value && amt.value) &&
          claimsList.value.length
        ) {
          // clear diagnosis addition card
          diagnosisCard.value = false;
          // true claims
          claimsCard.value = false;
          claimsDisplayCard.value = true;
          claimsSubmitCard.value = true;
          // clear everything about diagnosis (in case it's still active)
          diagnosis.value = null;

          // reset error (if required)
          error.value = false;

          // delay submit pulse
          setTimeout(() => {
            submitPulse.value = true;
          }, 5000);
        } else {
          // set error
          error.value = true;
          // set pulse
          if (selectedItem.value && qty.value && amt.value) {
            addPulse.value = true;
          }
        }
      } else if (next === "moreClaims") {
        // clear diagnosis addition card
        diagnosisCard.value = false;
        // true claims
        claimsCard.value = true;
        claimsDisplayCard.value = false;
        claimsSubmitCard.value = false;
        // clear everything about diagnosis
        diagnosis.value = null;

        // reset error (if required)
        error.value = false;
      }

      // open display
      if (claimsList.value.length) {
        claimsDisplayCard.value = true;
      }

      if (["claims", "moreClaims"].includes(next) && claimsCard.value) {
        await nextTick();
        claimsCardElement.value?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };

    // watch qty & price
    const handlePricing = () => {
      amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(2);
    };

    // filter components
    const handleSearch = (val) => {
      if (val.item) {
        // sort new search
        responseSearch.value = responseDefault.value.filter((x) =>
          x.item.toLowerCase().includes(val.item.toLowerCase())
        );
      } else {
        // empty search array
        responseSearch.value = [];

        // clear entry
        claimInputClear();
      }
    };

    // null reset
    const handleClear = (val) => {
      resetClaim.value = val.item;
      editClaim.value = val.item;
    };

    // get option
    const handlePick = (val) => {
      //set
      selectedItem.value = val.item;

      //set
      if (selectedItem.value) {
        // get the price out
        responseSearch.value.forEach((x) => {
          if (x.item === selectedItem.value) {
            // found
            selectedPrice.value = x.price;
          }
        });

        // set quantity & amount
        qty.value = 1;
        amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(
          2
        );
      } else {
        // if null (very unlikely)
        // clear entry
        claimInputClear();
      }
    };

    // watch updates
    watchEffect(() => {
      if (diagnosisList.value.length) {
        context.emit("update", {
          claimsDisplayCard: claimsDisplayCard.value,
          claimsSubmitCard: claimsSubmitCard.value,
          claimsList: claimsList.value,
          diagnosisList: diagnosisList.value,
          submitPulse: submitPulse.value,
        });
      }
    });

    // handle delete/edit requests
    const reviewClaim = (val) => {
      if (val) {
        if (val.action == "edit") {
          handleEdit(val.claim);
        } else if (val.action == "delete") {
          handleDelete(val.claim);
        } else if (val.action == "clear") {
          handleClearClaims();
        }
      }
    };

    // watch for changes
    watch(props, (newVal) => {
      if (newVal.claimItem) {
        reviewClaim(newVal.claimItem);
        context.emit("clear", {
          id: "claim",
          value: null,
        });
      }
    });

    // watch more changes
    watch(props, (newVal) => {
      if (newVal.editDiagnosis) {
        handleReviewDiagnosis();
      }
    });

     // watch even more changes
     watch(props, (newVal) => {
      if (newVal.next) {
        handleNext(newVal.next);
        context.emit("clear", {
          id: "next",
          value: null,
        });
      }
    });

    return {
      uiTemplate,
      tariffPreviewSearchInput,
      handleClearInput,
      handleClaimCancel,
      handleDiagnosis,
      handlePricing,
      handleDelete,
      handleEdit,
      handleClaims,
      handleTariffReload,
      handleTariffPreview,
      handleTariffPreviewClose,
      handleReviewDiagnosis,
      handleNext,
      handleSearch,
      handleClear,
      handlePick,
      handleRefresh,
      totalSent,
      selectedItem,
      selectedPrice,
      resetDiagnosis,
      editClaim,
      editId,
      resetClaim,
      filterData,
      filteredTariffPreview,
      formatMoney,
      hasTariffs,
      isTariffLoading,
      isTariffPreviewOpen,
      tariffMessage,
      tariffModalId,
      tariffPreviewSearch,
      isSubmitting,
      error,
      addPulse,
      diagnosis,
      diagnosisSaveError,
      diagnosisList,
      diagnosisCard,
      diagnosisCardElement,
      claimsDisplayCard,
      claimsList,
      claimsCard,
      claimsCardElement,
      claim,
      qty,
      amt,
    };
  },
};
</script>
  
<style>
@layer components {
  .tariff-preview-overlay { align-items: center; box-sizing: border-box; color: var(--ui-foreground); display: flex; font-family: var(--ui-font-sans); justify-content: center; padding: 1.5rem; }
  .tariff-preview-overlay .tariff-preview-modal { bottom: auto !important; box-sizing: border-box; left: auto !important; max-height: min(80dvh, 48rem) !important; max-width: min(56rem, calc(100vw - 3rem)) !important; overflow: hidden !important; position: relative !important; right: auto !important; top: auto !important; width: 100% !important; }
  .tariff-preview-heading { align-items: center; border-bottom: 1px solid var(--ui-border); display: flex; flex: 0 0 auto; gap: 1rem; justify-content: space-between; padding: 1.25rem 1.5rem; }
  .tariff-preview-heading h2 { color: var(--ui-foreground); font-size: 1.125rem; font-weight: 600; line-height: 1.5; margin: 0; }
  .tariff-preview-heading p { color: var(--ui-muted-foreground); font-size: .8125rem; line-height: 1.5; margin: .25rem 0 0; }
  .tariff-preview-overlay .tariff-preview-close { align-items: center; background: var(--ui-background); border: 1px solid var(--ui-border); border-radius: calc(var(--ui-radius) - 2px); color: var(--ui-muted-foreground); display: flex; flex: 0 0 auto; height: 2.25rem; justify-content: center; position: static !important; width: 2.25rem; }
  .tariff-preview-overlay .tariff-preview-close i { color: inherit; font-size: 1.125rem; line-height: 1; }
  .tariff-preview-overlay .tariff-preview-content { flex: 1 1 auto; min-height: 0; overflow-y: auto !important; padding: 1.25rem 1.5rem !important; }
  .tariff-preview-overlay .tariff-preview-search { display: grid; gap: .5rem; margin: 0 !important; }
  .tariff-preview-search label { color: var(--ui-foreground); font-size: .75rem; font-weight: 500; position: static; transform: none; }
  .tariff-preview-overlay .tariff-preview-search input { background: var(--ui-background) !important; border: 1px solid var(--ui-input) !important; border-radius: calc(var(--ui-radius) - 2px) !important; box-sizing: border-box; color: var(--ui-foreground); font: inherit; font-size: .875rem; height: 2.75rem !important; margin: 0 !important; padding: 0 .75rem !important; width: 100% !important; }
  .tariff-preview-count { color: var(--ui-muted-foreground); font-size: .75rem; margin: 1rem 0 .5rem; }
  .tariff-preview-overlay .tariff-preview-list { border: 1px solid var(--ui-border); border-radius: calc(var(--ui-radius) - 2px); list-style: none !important; margin: 0 !important; max-height: none !important; overflow: visible !important; padding: 0 !important; }
  .tariff-preview-overlay .tariff-preview-list .collection-item { align-items: start; background: transparent !important; border: 0 !important; border-bottom: 1px solid var(--ui-border) !important; display: grid; font-size: .8125rem; gap: 1.25rem; grid-template-columns: minmax(0, 1fr) auto; line-height: 1.6; padding: .85rem 1rem !important; }
  .tariff-preview-list .collection-item > span { overflow-wrap: anywhere; }
  .tariff-preview-overlay .tariff-preview-list .collection-item:last-child { border-bottom: 0 !important; }
  .tariff-preview-overlay .tariff-preview-list .secondary-content { color: var(--ui-foreground) !important; float: none !important; font-size: .8125rem; font-weight: 600; position: static !important; white-space: nowrap; }
  .tariff-preview-overlay .tariff-preview-footer { background: var(--ui-muted); border-top: 1px solid var(--ui-border); display: flex; flex: 0 0 auto; justify-content: flex-end; padding: 1rem 1.5rem !important; }
  .tariff-preview-done { background: var(--ui-primary); border: 1px solid var(--ui-primary); border-radius: calc(var(--ui-radius) - 2px); color: var(--ui-primary-foreground); cursor: pointer; font: inherit; font-size: .8125rem; font-weight: 600; min-height: 2.5rem; padding: .5rem 1rem; }
  .tariff-preview-overlay :is(button, input):focus-visible { outline: 2px solid var(--ui-ring); outline-offset: 2px; }
  @media (max-width: 600px) { .tariff-preview-overlay { padding: 1rem; } .tariff-preview-overlay .tariff-preview-modal { max-height: calc(100dvh - 2rem) !important; max-width: calc(100vw - 2rem) !important; } .tariff-preview-heading { padding: 1rem; } .tariff-preview-overlay .tariff-preview-content, .tariff-preview-overlay .tariff-preview-footer { padding: 1rem !important; } }
}
.claim-collection-add-card,
.claim-collection-add-card .card-content,
.claim-add-card,
.claim-add-card .card-content,
.claim-collection-add-card form,
.claim-add-card form,
.claim-collection-add-card .row,
.claim-add-card .row,
.claim-collection-add-card .input-field,
.claim-add-card .input-field {
  overflow: visible;
}

.claim-collection-add-card,
.claim-add-card {
  background: #ffffff !important;
  border: 1px solid #dbe5e9;
  border-radius: 6px;
  box-shadow: none;
  margin: 18px 30px 0;
  overflow: visible;
  position: relative;
  scroll-margin-top: 210px;
  width: calc(100% - 60px);
  z-index: 20;
}

.claim-collection-add-card.red.lighten-5,
.claim-add-card.red.lighten-5 {
  background: #fff8f8 !important;
  border-color: #ffcdd2;
}

.claim-collection-add-card > .card-content,
.claim-add-card > .card-content {
  padding: 24px 24px 20px !important;
}

.claim-collection-add-card .card-title,
.claim-add-card .card-title {
  color: #263238;
  font-size: 1.05rem;
  font-weight: 700;
}

.claim-collection-add-card .input-field,
.claim-add-card .input-field {
  margin-bottom: 0;
}

.claim-collection-add-card .claim-diagnosis-field,
.claim-add-card .claim-item-field {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  min-width: 0;
}

.claim-collection-add-card .claim-diagnosis-field > label,
.claim-add-card .claim-item-field > label {
  color: #455a64 !important;
  display: block;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 8px;
  order: 0;
  position: static !important;
  transform: none !important;
  transform-origin: initial !important;
}

.claim-collection-add-card .claim-diagnosis-field > input,
.claim-add-card .claim-item-field > input {
  box-sizing: border-box !important;
  margin: 0 !important;
  order: 1;
  padding: 0 14px !important;
  width: 100% !important;
}

.claim-collection-add-card .autocomplete-content.dropdown-content {
  max-height: 320px;
  overflow-y: auto;
  z-index: 1200;
}

.claim-add-card .tariff-card-actions {
  align-items: center;
  display: inline-flex;
  gap: 3px;
  margin-top: -2px;
}

.claim-add-card .tariff-card-actions .tariff-card-icon-action.btn-flat {
  align-items: center;
  background-color: #ffffff !important;
  border: 1px solid rgba(84, 110, 122, 0.22);
  border-radius: 18px;
  box-shadow: 0 5px 12px -10px rgba(38, 50, 56, 0.8);
  display: inline-flex;
  height: 34px;
  justify-content: center;
  line-height: 34px;
  min-width: 34px;
  padding: 0;
  width: 34px;
}

.claim-add-card .tariff-card-actions .tariff-card-icon-action.btn-flat:hover {
  background-color: #f8fafb !important;
}

.claim-add-card .tariff-card-actions .tariff-card-icon-action i,
.claim-add-card .tariff-card-actions .tariff-mini-spin {
  color: #546e7a !important;
  font-size: 20px;
  line-height: 20px;
}

.claim-add-card .tariff-card-actions .tariff-mini-spin {
  animation: tariff-spin 0.9s linear infinite;
  align-items: center;
  background-color: #ffffff !important;
  border: 1px solid rgba(84, 110, 122, 0.22);
  border-radius: 18px;
  box-shadow: 0 5px 12px -10px rgba(38, 50, 56, 0.8);
  display: inline-flex;
  height: 34px;
  justify-content: center;
  text-align: center;
  width: 34px;
}

.tariff-card-message {
  background: #fff8e1;
  border: 1px solid #ffecb3;
  border-radius: 6px;
  color: #6d4c41;
  margin: 8px 0 0;
  padding: 10px 12px;
}

.claim-entry-actions {
  align-items: center;
  background: #f8fafb;
  border: 0;
  border-top: 1px solid #e1e8eb;
  border-radius: 0;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin: 18px -24px -20px;
  min-height: 70px;
  padding: 13px 24px !important;
}

.claim-entry-actions .claim-entry-spacer {
  display: none;
}

.claim-entry-button {
  appearance: none;
  border-radius: 6px;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  float: none !important;
  font-size: 0.86rem;
  font-weight: 800;
  height: 42px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 42px;
  margin: 0;
  min-width: 142px;
  padding: 0 16px;
  text-decoration: none;
  text-transform: uppercase;
  width: auto !important;
}

.claim-entry-button i {
  font-size: 20px;
  line-height: 20px;
  margin-right: 8px;
}

.claim-entry-actions .claim-entry-cancel {
  background-color: #ffffff !important;
  border: 1px solid #cfd8dc;
  color: #455a64 !important;
  margin-right: auto;
}

.claim-entry-actions .claim-entry-cancel i {
  color: #00897b !important;
}

.claim-entry-actions .claim-entry-primary {
  background-color: #263238 !important;
  border: 1px solid #263238;
  color: #ffffff !important;
}

.claim-entry-actions .claim-entry-primary.green {
  background-color: #00897b !important;
  border-color: #00897b;
}

.claim-entry-actions .claim-entry-next {
  background-color: #ffffff !important;
  border: 1px solid #cfd8dc;
  color: #263238 !important;
}

.claim-entry-actions .claim-entry-next i {
  color: #00897b !important;
}

.claim-entry-actions .claim-entry-primary:hover,
.claim-entry-actions .claim-entry-next:hover,
.claim-entry-actions .claim-entry-cancel:hover {
  box-shadow: none;
  transform: translateY(-1px);
}

.claim-entry-actions .claim-entry-cancel:hover,
.claim-entry-actions .claim-entry-next:hover {
  border-color: #b9c8ce;
  background-color: #ffffff !important;
}

.tariff-preview-overlay {
  background: rgba(38, 50, 56, 0.48);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1200;
}

.tariff-preview-modal {
  background: #fff;
  bottom: 32px;
  box-shadow: 0 18px 45px rgba(38, 50, 56, 0.24);
  display: flex;
  flex-direction: column;
  left: max(36px, calc((100vw - 1180px) / 2));
  position: fixed;
  right: max(36px, calc((100vw - 1180px) / 2));
  top: 104px;
  z-index: 1201;
}

.tariff-preview-content {
  flex: 1;
  overflow: hidden;
  padding: 32px 36px 20px;
}

.tariff-preview-search {
  margin-bottom: 22px;
  margin-top: 22px;
}

.tariff-preview-list {
  max-height: calc(100vh - 330px);
  overflow-y: auto;
}

.tariff-preview-close {
  background: #eceff1;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  height: 36px;
  position: absolute;
  right: 24px;
  top: 22px;
  width: 36px;
}

.tariff-preview-close i {
  color: #455a64;
  line-height: 36px;
}

.tariff-preview-footer {
  border-top: 1px solid #e0e0e0;
  padding-left: 36px;
  padding-right: 36px;
  text-align: right;
}

@media only screen and (max-width: 992px) {
  .claim-collection-add-card,
  .claim-add-card {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }

  .claim-entry-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: -24px;
    margin-right: -24px;
  }

  .claim-entry-actions .claim-entry-spacer {
    display: none;
  }

  .claim-entry-actions .claim-entry-button {
    float: none !important;
    margin: 0;
    min-width: 0;
    order: 2;
    width: 100% !important;
  }

  .claim-entry-actions .claim-entry-primary {
    order: 1;
  }

  .claim-entry-actions .claim-entry-next {
    order: 2;
  }

  .claim-entry-actions .claim-entry-cancel {
    order: 3;
  }
}

@media only screen and (max-width: 600px) {
  .tariff-preview-modal {
    bottom: 12px;
    left: 12px;
    right: 12px;
    top: 76px;
  }

  .tariff-preview-content {
    padding: 24px 18px 16px;
  }

  .tariff-preview-list {
    max-height: calc(100vh - 292px);
  }
}

@keyframes tariff-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
  
